export const setMinimumPrecision = (value, precision) => {
  if (value === null || value === '' || isNaN(Math.floor(value))) {
    return value
  } else if (!value.toString().includes('.')) {
    return parseFloat(value).toFixed(precision)
  } else {
    return value.toString().split(".")[1].length < precision ? parseFloat(value).toFixed(precision) : value;
  }
}
